<template>
    <div class="productService">
        <a-card>
            <a-form-model layout="inline" ref="searchForm">
                <a-form-model-item label="产品服务">
                    <a-input placeholder="请输入" allow-clear :maxLength="25" v-model="search.name" @change="e => search.name = e.target.value.replace(/\s*/g, '')"/>
                </a-form-model-item>
                <a-form-model-item label="类型">
                    <a-select allowClear v-model="search.type" placeholder="请选择" style="width:198px;">
                        <a-select-option :value="1">测评</a-select-option>
                        <a-select-option :value="2">训练</a-select-option>
                        <a-select-option :value="3">教学</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="primary" @click="getList(1)">查询</a-button>
                    <a-button style="margin: 0 35px 0 15px;" @click="resetSearch()">重置</a-button>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="primary" @click="add()" icon="plus" v-permission="`Content.ProductService.Add`">添加服务</a-button>
                </a-form-model-item>
            </a-form-model>
            <div class="table">
                <a-table
                    class="components-table-demo-nested"
                    :columns="columns"
                    rowKey="id"
                    :loading="loading"
                    :dataSource="dataSource"
                    :pagination="{
                        current: search.pageIndex,
                        pageSize: search.pageSize,
                        total: total,
                        showSizeChanger: true,
                        showLessItems: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
                        onChange: onPageChange,
                        onShowSizeChange: onSizeChange,
                    }"
                >
                    <span slot="createTimeIcon">
                        <div class="createTime">
                            添加时间 
                            <span class="createTimeIcon">
                                <a-icon type="caret-up" :class="activeUp ? 'active' : ''" @click="sorterUp()"/>
                                <a-icon type="caret-down" :class="activeDown ? 'active' : ''" @click="sorterDown()"/>
                            </span> 
                        </div>
                    </span>
                    <div slot="type" slot-scope="text,record">
                        <span v-if="record.type == 1">测评</span>
                        <span v-if="record.type == 2">训练</span>
                        <span v-if="record.type == 3">教学</span>
                    </div>
                    <div slot="enabled" slot-scope="text,record" v-auth="`Content.ProductService.Enabled`">
                        <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled" @click="StatusChange(record)"/>
                    </div>
                    <div slot="action" slot-scope="text, record">
                        <a @click="edit(record)" style="margin-right: 8px" v-permission="`Content.ProductService.Edit`">
                            <a-icon type="edit"/>编辑
                        </a>
                        <a-popconfirm
                            title="确定删除？"
                            ok-text="确定"
                            cancel-text="取消"
                            @confirm="deleteRecord(record)"
                            v-permission="`Content.ProductService.Delete`"
                        >
                            <a style="color: #f00;margin-right: 8px">
                                <a-icon type="delete"/>删除
                            </a>
                        </a-popconfirm>
                    </div>
                </a-table>
            </div>
        </a-card>
    </div>
</template>

<script>
const columns = [
    { title: "产品服务", dataIndex: "name",align: "center" },
    { title: "类型", scopedSlots: { customRender: "type" }, align: "center" },
    { title: "状态", scopedSlots: { customRender: "enabled" }, align: "center" },
    { 
        // title: "添加时间", 
        dataIndex: "createTime", 
        align: "center" ,
        slots: { title: 'createTimeIcon' }
    },
    { title: "操作", scopedSlots: { customRender: "action" }, align: "center" }
];
export default {
    name:'ProductService',
    data () {
        return {
            // 参数
            search: {
                name:'',//产品服务
                type:undefined,//类型
                desc:true,
                pageIndex:1,
                pageSize:10,
            },
            total:0,//总数
            columns: columns,//表头
            loading: true,//是否加载
            dataSource: [],//表格数据
            activeUp:true,
            activeDown:false,
        }
    },
    created () {
        this.getList()
    },
    methods: {
        // 列表
        getList(pageIndex){
            if (pageIndex){
                this.search.pageIndex = pageIndex; 
            }
            this.$http.productServiceList(this.search)
            .then(res => {
                this.loading = false;
                    this.dataSource = res.data.data.items;
                    this.total = res.data.data.totalCount;
            })
            .catch(err => {
                this.loading = false;
                this.$message.destroy()
                this.$message.error(res.data.message)
            })
        },
        sorterUp(){
            this.search.desc = true
            this.activeUp = true
            this.activeDown = false
            this.getList()
        },
        sorterDown(){
            this.search.desc = false
            this.activeDown = true
            this.activeUp = false
            this.getList()
        },
        // 添加
        add(){
            this.$router.push({
                path:'/content/ProductServiceSeting',
                query:{
                    type:'add'
                }
            })
        },
        // 编辑
        edit(record){
            sessionStorage.setItem('ProductServiceItem',JSON.stringify(record))
            this.$router.push({
                path:'/content/ProductServiceSeting',
                query:{
                    id:record.id,
                    type:'edit'
                }
            })
        },
        // 删除
        deleteRecord(record){
            let formData = new FormData()
            formData.append('id',record.id)
            this.$http.productServiceDelete(formData)
            .then(res => {
                this.loading = false;
                this.$message.destroy();
                    this.$message.success('操作成功');
                    this.getList();
               
            })
            .catch(err => {
                this.loading = false;
                this.$message.destroy();
                this.$message.error(res.data.message);
            })
        },
        // 修改状态
        StatusChange(record){
            let formData = new FormData()
            formData.append('id',record.id)
            this.$http.productServiceStatue(formData)
            .then(res => {
                this.loading = false;
                this.$message.destroy();
                    this.$message.success('操作成功');
                    this.getList();
               
            })
            .catch(err => {
                this.loading = false;
                this.$message.destroy();
                this.$message.error(res.data.message);
            })
        },
        // 切换页码
        onPageChange(pageIndex, size) {
            this.search = {
                name:'',//产品服务
                type:undefined,//类型
                pageIndex:pageIndex,
                pageSize:10,
            }
            this.getList();
        },
        // 切换条数
        onSizeChange(pageIndex, size) {
            this.search.pageIndex = 1;
            this.search.pageSize = size;
            this.getList();
        },
        // 重置搜索
        resetSearch(){
            this.search = {
                name:'',//产品服务
                type:undefined,//类型
                pageIndex:1,
                pageSize:10,
            }
            this.getList();
        },
    }
}
</script>

<style scoped lang="less">
.table {
    margin-top: 24px;
}
.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner{
    color:#bfbfbf !important;
}
.createTime{
    display: flex;
    align-items: center;
    .createTimeIcon{
        display: flex;
        flex-direction: column;
        margin-left: 5px;
        color:#bfbfbf;
        cursor: pointer;
    }
    .active{
        color:#13c2c2;
    }
}
</style>
